




































































import { Component, Vue } from 'vue-property-decorator'
import { getPrizeList, savePrize, updatePrize, deletePrize } from '@/api/lottery'

@Component({ name: 'LotteryPrize' })
export default class extends Vue {
  private tableData: any[] = []
  private dialogVisible = false
  private form: any = this.defaultForm()

  created() { this.loadList() }

  defaultForm() {
    return { id: null, name: '', type: 0, prizeValue: 0, dishId: null, minAmount: 0, probability: 10, status: 1, sort: 0 }
  }

  typeText(type: number) {
    return ['谢谢参与', '余额', '满减券', '免费菜'][type] || '未知'
  }

  async loadList() {
    const res: any = await getPrizeList()
    if (String(res.data.code) === '1') {
      this.tableData = res.data.data
    }
  }

  openDialog(row?: any) {
    this.form = row ? { ...row } : this.defaultForm()
    this.dialogVisible = true
  }

  async submitForm() {
    const api = this.form.id ? updatePrize : savePrize
    const res: any = await api(this.form)
    if (String(res.data.code) === '1') {
      this.$message.success('保存成功')
      this.dialogVisible = false
      this.loadList()
    }
  }

  handleDelete(id: number) {
    this.$confirm('确定删除该奖品吗？', '提示').then(async () => {
      await deletePrize(id)
      this.$message.success('已删除')
      this.loadList()
    })
  }
}
